import {
  ROLES,
  type RoleStrategy,
  api,
  useMutation,
  useQueryClient,
  useRoleConf,
  useToaster,
} from "@pharmupp/p3-front-commons"
import { useParams } from "react-router-dom"
import type { ApiFormEventReceived } from "../model"

export const useCancelEventApi = () => {
  const queryClient = useQueryClient()
  const toaster = useToaster()
  const { id: eventId } = useParams()
  const getEndpoint = useRoleConf(apiRoleConf)

  const { mutateAsync: cancelEvent } = useMutation({
    mutationFn: (formValues: ApiCancelEventBody) =>
      api.put<ApiFormEventReceived>(getEndpoint(eventId!), {
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formValues),
      }),
    onSuccess(data) {
      queryClient.setQueryData(["news", "events", "form", eventId], data)
      toaster.success("Évènement annulé")
    },
    onError: () => toaster.error("Une erreur est survenue"),
  })

  return {
    cancelEvent,
  }
}

export interface ApiCancelEventBody {
  cancellationReason?: string
}

const presidentApiRoleConf = (id: string) => `/api/news/upp/event/${id}/cancel`

const apiRoleConf: RoleStrategy<(id: string) => string> = {
  [ROLES.ADMIN]: (id) => `/api/news/event/${id}/cancel`,
  [ROLES.UPP_PRESIDENT]: presidentApiRoleConf,
  [ROLES.UPP_REPRESENTATIVE]: presidentApiRoleConf,
}
